<template>
  <div
    ref="rtSteps"
    class="rt-steps-wrap"
    :class="{ 'rt-step-has-desc': hasDesc, 'is-evenly': mode === 'evenly','rt-step-empty': !stepOptions.length }"
  >
    <el-scrollbar v-if="stepOptions.length">
      <div
        class="rt-steps"
        :class="{ 'rt-step-click': !disabled }"
      >
        <div
          v-for="(item, index) in stepOptions"
          :key="index"
          class="rt-steps-item-container"
          :class="{
            'rt-steps-selected': selectedIndex == index
          }"
        >
          <div
            :class="{
              isfinished: index <= currentIndex,
              nofirst: !!index
            }"
            class="rt-step"
            @click="stepClick(index)"
          >
            <rt-icon
              :name="item.icon ? item.icon : 'rt-base-circle-line'"
              :size="item.icon ? 16 : 10"
            ></rt-icon>
            <span class="step-content">{{ item.Text }}</span>
          </div>
          <rt-tooltip
            v-if="item.desc"
            :disabled="descTooltip[index]"
            :content="item.desc"
            placement="bottom"
          >
            <div
              :ref="`descItem${index}`"
              :class="descClass"
              class="step-desc"
            >
              {{ item.desc }}
            </div>
          </rt-tooltip>
        </div>
        <div
          :style="lineStyle"
          class="bottom-line"
        />
      </div>
    </el-scrollbar>
    <rt-default-image
      v-else
      v-bind="$attrs"
      :text="text"
    >
      <div slot="describe">
        <slot name="describe">
          {{ $tx('暂无数据', 'xpc.uploadfile.nodata') }}
        </slot>
      </div>
    </rt-default-image>
  </div>
</template>

<script>
export default {
  name: 'RtSteps',
  props: {
    stepType: {
      // 步骤条类型 1：绑定picklist字段 2：自定义值
      type: Number,
      default: 1,
      required: true
    },
    entity: {
      // 实体名
      type: String,
      default: '',
      required: false
    },
    attribute: {
      // 字段名
      type: String,
      default: '',
      required: false
    },
    value: {
      // 当前值
      type: Number,
      default: 0,
      required: false
    },
    valueField: {
      type: String,
      default: 'Value'
    },
    options: {
      // 自定义时 直接传options值过来
      type: Array,
      default: () => [],
      required: false
    },
    // 是否可以点击
    disabled: {
      type: Boolean,
      default: false
    },
    // 描述文字的类名
    descClass: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'default',
      validator: (val) => {
        return ['default', 'evenly'].includes(val);
      }
    },
    text: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      stepOptions: [],
      selectedIndex: 0,
      lineStyle: {},
      descTooltip: []
    };
  },
  computed: {
    hasDesc () {
      return this.stepOptions.some(item => item.desc);
    },
    currentIndex () {
      if (this.stepOptions && this.stepOptions.length > 0) {
        return this.stepOptions.findIndex(option => option[this.valueField] === this.value);
      }
      return this.value;
    }
  },
  watch: {
    value (newValue) {
      this.$nextTick(() => {
        this.calcBarStyle();
      });
    },
    stepOptions: {
      handler (val) {
        this.$nextTick(() => {
          this.descTooltip = val.map((item, index) => {
            return !!item.desc &&
                this.$refs[`descItem${index}`][0].clientWidth >=
                this.$refs[`descItem${index}`][0].scrollWidth
          })
        });
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function () {
    if (this.stepType === 1) {
      this.bindPicklist();
    } else {
      this.getStepOptions(this.options);
    }
    this.selectedIndex = this.currentIndex;

    this.$nextTick(() => {
      this.calcBarStyle();
      if (typeof ResizeObserver === 'function') {
        const resizeOb = new ResizeObserver(() => {
          this.calcBarStyle();
        });

        resizeOb.observe(this.$refs.rtSteps);

        this.$once('hook:beforeDestroy', () => {
          resizeOb.unobserve(this.$refs.rtSteps);
        });
      }
    });
  },
  methods: {
    bindPicklist () {
      let { params, entity, attribute } = this;
      params = Object.assign({}, params, { entity, attribute });
      this.$picklist
        .getPicklistData(params)
        .then(res => {
          this.getStepOptions(res);
        })
        .catch(error => {
          rt.showErrorToast(error.message);
        });
    },
    getStepOptions (options) {
      const optionsHasValueLength = options.reduce((count, option) => {
        if (option.hasOwnProperty(this.valueField)) {
          count++;
        }
        return count;
      }, 0)
      if (optionsHasValueLength === 0) {
        this.stepOptions = options.map((option, index) => {
          option[this.valueField] = index;
          return option;
        });
      } else if (optionsHasValueLength < options.length) {
        throw (new Error(`请将 options 中的 ${this.valueField} 字段补充完整`))
      } else {
        this.stepOptions = options;
      }
    },
    stepClick (index) {
      if (this.disabled) return;
      this.selectedIndex = index;
      this.$nextTick(() => {
        this.calcBarStyle();
      });
      this.$emit('step-click', index);
    },
    calcBarStyle () {
      const step = this.$refs.rtSteps.querySelector('.rt-steps-selected');
      if (!step) {
        return;
      }
      const width = step.offsetWidth - 48;
      const translateX = step.offsetLeft - 16;
      this.lineStyle = {
        width: `${width}px`,
        transform: `translateX(${translateX}px)`
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// main.vue?06fb6bd6